module.exports = __webpack_public_path__ + "img/mtnLine.a0f2d1a4.png";